import { fastEqual } from '@flowus/common/utils/tools';
import { useSelector as reduxSelector, useStore } from 'react-redux';
import type { RootState } from 'src/redux/types';
import { useContextSelector } from 'use-context-selector';
import { StoreContext } from './context';
import { PageScene, usePageScene } from 'src/views/main/scene-context';

interface Options<T> {
  equalityFn?: (left: T, right: T) => boolean;
  once?: boolean;
}

// const debugMap = new Map<string, number>();
export const useFineSelector = <T>(f: ($state: RootState) => T, opt?: Options<T>) => {
  const { equalityFn } = opt || {};

  const zustandSelector = useContextSelector(StoreContext, (state) => state.$state);
  const isInit = useContextSelector(StoreContext, (state) => state.isInit);
  const isChartPreview = usePageScene() === PageScene.PAGE_CHART; // 这个StoreContext有bug，只要当前页面没有render就一直无法回调
  const once = useContextSelector(StoreContext, (state) => state.once);
  const store = useStore();

  if (once || opt?.once) {
    return (() => {
      return f(store.getState());
    })();
  }

  if (isInit && !isChartPreview) {
    return zustandSelector(() => {
      return f(store.getState());
    }, equalityFn ?? fastEqual);
  }

  return reduxSelector(f, equalityFn ?? fastEqual);
};

export const useFuSelector = useFineSelector;
